import React, { useEffect, useState } from "react";
import { GetClinicData } from "./API";
import ClinicList from "./ClinicList";
import { Translate } from 'react-localize-redux';

export default function Clinic() {
  const [camp, setCamp] = useState('1')
  return (
    <div>
      <div class="card"><div class="card-block">
        <h4 class="card-title m-t-0">
          <Translate id="general.Clinic_Reservation"/> - {camp == "1" ? <Translate id="general.AbukirBranch"/> : <Translate id="general.MiamiBranch"/>}
        </h4>
        <p class="card-text">
        <Translate id="general.Clinic_Description"/>
        </p>
        <div class="row">
          <div class="col-12 col-md-4"></div>
              <div class="col-12 col-md-4">
               
                 
           

            <div class="btn-group dropdown  btn-block ">
									<button class="btn btn-block btn-primary " data-toggle="dropdown" aria-expanded="false">
                  <Translate id="general.Select_Clinic"/> 
                  <span class="caret m-l-3"></span>
									</button>
									<ul class="dropdown-menu text-left" x-placement="bottom-start">
                  <li><a onClick={(event) => setCamp(1)}><i class="fas fa-lg fa-fw m-r-10 fa-hospital"></i> <Translate id="general.AbukirBranch"/></a></li>
                <li><a  onClick={(event) => setCamp(2)}><i class="fas fa-lg fa-fw m-r-10 fa-hospital"></i> <Translate id="general.MiamiBranch"/></a></li>
									</ul>
								</div>
                
              </div>
            </div>
          </div>
        </div>
        <div class="alert alert-yellow text-center" role="alert"><Translate id="general.Clinic_Notes"/></div>
      <ClinicList camp={camp} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Clinic/Clinic.js